/**
 * The history of an item (a trait, an insight): a date and what happened.
 *
 * Every entry leaves with an `id`, because the shared `TraitHistory` keys its
 * rows on it. Two entries can share a timestamp, so `at` alone is not unique;
 * the fallback still contains the position, but it is computed ONCE here and
 * travels with the entry, instead of being reassigned by position on every
 * render.
 *
 * @param {Array<object>|undefined} raw — the payload's `history`.
 * @returns {Array<{ id: string, at: string|null, text: string }>}
 */
export const mapHistoryEntries = (raw) =>
  (raw ?? []).map((entry, index) => ({
    id: entry.id ?? entry.event_id ?? entry.eventId ?? `${entry.at ?? 'unknown'}-${index}`,
    at: entry.at ?? null,
    text: entry.text ?? '',
  }));
